import _definePage_default_0 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/Books/index.vue?definePage&vue'
import _definePage_default_4 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/Books/BooksList.vue?definePage&vue'
import _definePage_default_5 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/index.vue?definePage&vue'
import _definePage_default_6 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/ahli-pbt.vue?definePage&vue'
import _definePage_default_7 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/pasar-pbt.vue?definePage&vue'
import _definePage_default_8 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/pbtcare.vue?definePage&vue'
import _definePage_default_9 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/penguatkuasaan-pbt.vue?definePage&vue'
import _definePage_default_10 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/senarai-pbt.vue?definePage&vue'
import _definePage_default_11 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kampung-baru/index.vue?definePage&vue'
import _definePage_default_12 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kampung-baru/index copy.vue?definePage&vue'
import _definePage_default_13 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kawalan-pemajuan/index.vue?definePage&vue'
import _definePage_default_14 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/index.vue?definePage&vue'
import _definePage_default_15 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/cctv.vue?definePage&vue'
import _definePage_default_16 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/cerun.vue?definePage&vue'
import _definePage_default_17 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/jalan.vue?definePage&vue'
import _definePage_default_18 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/jalan copy.vue?definePage&vue'
import _definePage_default_19 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/spah.vue?definePage&vue'
import _definePage_default_20 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/index.vue?definePage&vue'
import _definePage_default_21 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kolam-renang.vue?definePage&vue'
import _definePage_default_22 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kolam-takungan.vue?definePage&vue'
import _definePage_default_23 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kumbahan-bukan-najis.vue?definePage&vue'
import _definePage_default_24 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/lampu-jalan.vue?definePage&vue'
import _definePage_default_25 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/perangkap-minyak.vue?definePage&vue'
import _definePage_default_26 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/perparitan.vue?definePage&vue'
import _definePage_default_27 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/index.vue?definePage&vue'
import _definePage_default_28 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit/sanitasi.vue?definePage&vue'
import _definePage_default_29 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit/tandas.vue?definePage&vue'
import _definePage_default_30 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit.vue?definePage&vue'
import _definePage_default_31 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit copy.vue?definePage&vue'
import _definePage_default_32 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/haiwan-terbiar.vue?definePage&vue'
import _definePage_default_33 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/kempen.vue?definePage&vue'
import _definePage_default_34 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/pasar-awam-pbt.vue?definePage&vue'
import _definePage_default_35 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/denggi.vue?definePage&vue'
import _definePage_default_36 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/dfic.vue?definePage&vue'
import _definePage_default_37 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/tikus.vue?definePage&vue'
import _definePage_default_38 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor.vue?definePage&vue'
import _definePage_default_39 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/index.vue?definePage&vue'
import _definePage_default_40 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/kewangan.vue?definePage&vue'
import _definePage_default_41 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/kpi.vue?definePage&vue'
import _definePage_default_42 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/latihan.vue?definePage&vue'
import _definePage_default_43 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/perjawatan.vue?definePage&vue'
import _definePage_default_44 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/skt.vue?definePage&vue'
import _definePage_default_45 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/login.vue?definePage&vue'
import _definePage_default_46 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/login-template.vue?definePage&vue'
import _definePage_default_47 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/menu/index.vue?definePage&vue'
import _definePage_default_48 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pembangunan/index.vue?definePage&vue'
import _definePage_default_49 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pembangunan/bajet-mengurus.vue?definePage&vue'
import _definePage_default_50 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengguna-api/index.vue?definePage&vue'
import _definePage_default_51 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/index.vue?definePage&vue'
import _definePage_default_52 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/ahli-majlis.vue?definePage&vue'
import _definePage_default_53 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/lesen.vue?definePage&vue'
import _definePage_default_54 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/pasar.vue?definePage&vue'
import _definePage_default_55 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/penguatkuasaan.vue?definePage&vue'
import _definePage_default_56 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/senarai.vue?definePage&vue'
import _definePage_default_57 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/index copy.vue?definePage&vue'
import _definePage_default_58 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/kwc.vue?definePage&vue'
import _definePage_default_59 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/ringkasan-peruntukan-dan-belanja-projek-bp1.vue?definePage&vue'
import _definePage_default_60 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/smk.vue?definePage&vue'
import _definePage_default_61 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/status-pelaksanaan-projek-bp1.vue?definePage&vue'
import _definePage_default_62 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-maklumat/index.vue?definePage&vue'
import _definePage_default_63 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-maklumat/ePBT.vue?definePage&vue'
import _definePage_default_64 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-pengguna/index.vue?definePage&vue'
import _definePage_default_65 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/ahli-pbt.vue?definePage&vue'
import _definePage_default_66 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/cctv.vue?definePage&vue'
import _definePage_default_67 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/e-book.vue?definePage&vue'
import _definePage_default_68 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/e-book copy.vue?definePage&vue'
import _definePage_default_69 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/fogt.vue?definePage&vue'
import _definePage_default_70 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/haiwan-terbiar.vue?definePage&vue'
import _definePage_default_71 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kempen.vue?definePage&vue'
import _definePage_default_72 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kesihatan.vue?definePage&vue'
import _definePage_default_73 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kolam-renang.vue?definePage&vue'
import _definePage_default_74 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/lampu-jalan.vue?definePage&vue'
import _definePage_default_75 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/oku.vue?definePage&vue'
import _definePage_default_76 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/osc.vue?definePage&vue'
import _definePage_default_77 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/osc1.vue?definePage&vue'
import _definePage_default_78 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pasar-awam.vue?definePage&vue'
import _definePage_default_79 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pasar-pbt.vue?definePage&vue'
import _definePage_default_80 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbt.vue?definePage&vue'
import _definePage_default_81 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbtcare.vue?definePage&vue'
import _definePage_default_82 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbtPay.vue?definePage&vue'
import _definePage_default_83 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/sanitasi.vue?definePage&vue'
import _definePage_default_84 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/spah.vue?definePage&vue'
import _definePage_default_85 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/tandas-awam.vue?definePage&vue'
import _definePage_default_86 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/test.vue?definePage&vue'
import _definePage_default_87 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/denggi.vue?definePage&vue'
import _definePage_default_88 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/dfic.vue?definePage&vue'
import _definePage_default_89 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/tikus.vue?definePage&vue'
import _definePage_default_90 from '/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/Books',
    /* internal name: 'books' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'books',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/Books/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'BooksList',
        name: 'books-books-list',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/Books/BooksList.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  {
    path: '/inspektorat',
    /* internal name: 'inspektorat' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'inspektorat',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/index.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: 'ahli-pbt',
        name: 'inspektorat-ahli-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/ahli-pbt.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: 'pasar-pbt',
        name: 'inspektorat-pasar-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/pasar-pbt.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'pbtcare',
        name: 'inspektorat-pbtcare',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/pbtcare.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'penguatkuasaan-pbt',
        name: 'inspektorat-penguatkuasaan-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/penguatkuasaan-pbt.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'senarai-pbt',
        name: 'inspektorat-senarai-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/inspektorat/senarai-pbt.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/kampung-baru',
    /* internal name: 'kampung-baru' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kampung-baru',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kampung-baru/index.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'index copy',
        name: 'kampung-baru-index copy',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kampung-baru/index copy.vue'),
        /* no children */
      },
  _definePage_default_12
  )
    ],
  },
  {
    path: '/kawalan-pemajuan',
    /* internal name: 'kawalan-pemajuan' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kawalan-pemajuan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kawalan-pemajuan/index.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/kejuruteraan-awam',
    /* internal name: 'kejuruteraan-awam' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kejuruteraan-awam',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/index.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: 'cctv',
        name: 'kejuruteraan-awam-cctv',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/cctv.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
  _mergeRouteRecord(
      {
        path: 'cerun',
        name: 'kejuruteraan-awam-cerun',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/cerun.vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'jalan',
        name: 'kejuruteraan-awam-jalan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/jalan.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
  _mergeRouteRecord(
      {
        path: 'jalan copy',
        name: 'kejuruteraan-awam-jalan copy',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/jalan copy.vue'),
        /* no children */
      },
  _definePage_default_18
  ),
  _mergeRouteRecord(
      {
        path: 'spah',
        name: 'kejuruteraan-awam-spah',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-awam/spah.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  },
  {
    path: '/kejuruteraan-kesihatan-umum',
    /* internal name: 'kejuruteraan-kesihatan-umum' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kejuruteraan-kesihatan-umum',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/index.vue'),
        /* no children */
      },
  _definePage_default_20
  ),
  _mergeRouteRecord(
      {
        path: 'kolam-renang',
        name: 'kejuruteraan-kesihatan-umum-kolam-renang',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kolam-renang.vue'),
        /* no children */
      },
  _definePage_default_21
  ),
  _mergeRouteRecord(
      {
        path: 'kolam-takungan',
        name: 'kejuruteraan-kesihatan-umum-kolam-takungan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kolam-takungan.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
  _mergeRouteRecord(
      {
        path: 'kumbahan-bukan-najis',
        name: 'kejuruteraan-kesihatan-umum-kumbahan-bukan-najis',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/kumbahan-bukan-najis.vue'),
        /* no children */
      },
  _definePage_default_23
  ),
  _mergeRouteRecord(
      {
        path: 'lampu-jalan',
        name: 'kejuruteraan-kesihatan-umum-lampu-jalan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/lampu-jalan.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
  _mergeRouteRecord(
      {
        path: 'perangkap-minyak',
        name: 'kejuruteraan-kesihatan-umum-perangkap-minyak',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/perangkap-minyak.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'perparitan',
        name: 'kejuruteraan-kesihatan-umum-perparitan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kejuruteraan-kesihatan-umum/perparitan.vue'),
        /* no children */
      },
  _definePage_default_26
  )
    ],
  },
  {
    path: '/kesihatan-persekitaran',
    /* internal name: 'kesihatan-persekitaran' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kesihatan-persekitaran',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/index.vue'),
        /* no children */
      },
  _definePage_default_27
  ),
  _mergeRouteRecord(
      {
        path: 'cegah-jangkit',
        name: 'kesihatan-persekitaran-cegah-jangkit',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit.vue'),
        children: [
  _mergeRouteRecord(
          {
            path: 'sanitasi',
            name: 'kesihatan-persekitaran-cegah-jangkit-sanitasi',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit/sanitasi.vue'),
            /* no children */
          },
  _definePage_default_28
  ),
  _mergeRouteRecord(
          {
            path: 'tandas',
            name: 'kesihatan-persekitaran-cegah-jangkit-tandas',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit/tandas.vue'),
            /* no children */
          },
  _definePage_default_29
  )
        ],
      },
  _definePage_default_30
  ),
  _mergeRouteRecord(
      {
        path: 'cegah-jangkit copy',
        name: 'kesihatan-persekitaran-cegah-jangkit copy',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/cegah-jangkit copy.vue'),
        /* no children */
      },
  _definePage_default_31
  ),
  _mergeRouteRecord(
      {
        path: 'haiwan-terbiar',
        name: 'kesihatan-persekitaran-haiwan-terbiar',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/haiwan-terbiar.vue'),
        /* no children */
      },
  _definePage_default_32
  ),
  _mergeRouteRecord(
      {
        path: 'kempen',
        name: 'kesihatan-persekitaran-kempen',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/kempen.vue'),
        /* no children */
      },
  _definePage_default_33
  ),
  _mergeRouteRecord(
      {
        path: 'pasar-awam-pbt',
        name: 'kesihatan-persekitaran-pasar-awam-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/pasar-awam-pbt.vue'),
        /* no children */
      },
  _definePage_default_34
  ),
  _mergeRouteRecord(
      {
        path: 'vektor',
        name: 'kesihatan-persekitaran-vektor',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor.vue'),
        children: [
  _mergeRouteRecord(
          {
            path: 'denggi',
            name: 'kesihatan-persekitaran-vektor-denggi',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/denggi.vue'),
            /* no children */
          },
  _definePage_default_35
  ),
  _mergeRouteRecord(
          {
            path: 'dfic',
            name: 'kesihatan-persekitaran-vektor-dfic',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/dfic.vue'),
            /* no children */
          },
  _definePage_default_36
  ),
  _mergeRouteRecord(
          {
            path: 'tikus',
            name: 'kesihatan-persekitaran-vektor-tikus',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/kesihatan-persekitaran/vektor/tikus.vue'),
            /* no children */
          },
  _definePage_default_37
  )
        ],
      },
  _definePage_default_38
  )
    ],
  },
  {
    path: '/khidmat-pengurusan',
    /* internal name: 'khidmat-pengurusan' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'khidmat-pengurusan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/index.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
  _mergeRouteRecord(
      {
        path: 'kewangan',
        name: 'khidmat-pengurusan-kewangan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/kewangan.vue'),
        /* no children */
      },
  _definePage_default_40
  ),
  _mergeRouteRecord(
      {
        path: 'kpi',
        name: 'khidmat-pengurusan-kpi',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/kpi.vue'),
        /* no children */
      },
  _definePage_default_41
  ),
  _mergeRouteRecord(
      {
        path: 'latihan',
        name: 'khidmat-pengurusan-latihan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/latihan.vue'),
        /* no children */
      },
  _definePage_default_42
  ),
  _mergeRouteRecord(
      {
        path: 'perjawatan',
        name: 'khidmat-pengurusan-perjawatan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/perjawatan.vue'),
        /* no children */
      },
  _definePage_default_43
  ),
  _mergeRouteRecord(
      {
        path: 'skt',
        name: 'khidmat-pengurusan-skt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/khidmat-pengurusan/skt.vue'),
        /* no children */
      },
  _definePage_default_44
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_45
  ),
  _mergeRouteRecord(
  {
    path: '/login-template',
    name: 'login-template',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/login-template.vue'),
    /* no children */
  },
  _definePage_default_46
  ),
  {
    path: '/menu',
    /* internal name: 'menu' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'menu',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/menu/index.vue'),
        /* no children */
      },
  _definePage_default_47
  )
    ],
  },
  {
    path: '/pembangunan',
    /* internal name: 'pembangunan' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pembangunan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pembangunan/index.vue'),
        /* no children */
      },
  _definePage_default_48
  ),
  _mergeRouteRecord(
      {
        path: 'bajet-mengurus',
        name: 'pembangunan-bajet-mengurus',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pembangunan/bajet-mengurus.vue'),
        /* no children */
      },
  _definePage_default_49
  )
    ],
  },
  {
    path: '/pengguna-api',
    /* internal name: 'pengguna-api' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pengguna-api',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengguna-api/index.vue'),
        /* no children */
      },
  _definePage_default_50
  )
    ],
  },
  {
    path: '/pengurusan-data',
    /* internal name: 'pengurusan-data' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pengurusan-data',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/index.vue'),
        /* no children */
      },
  _definePage_default_51
  ),
      {
        path: 'dasar',
        /* internal name: 'pengurusan-data-dasar' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'ahli-majlis',
            name: 'pengurusan-data-dasar-ahli-majlis',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/ahli-majlis.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
  _mergeRouteRecord(
          {
            path: 'lesen',
            name: 'pengurusan-data-dasar-lesen',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/lesen.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'pasar',
            name: 'pengurusan-data-dasar-pasar',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/pasar.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'penguatkuasaan',
            name: 'pengurusan-data-dasar-penguatkuasaan',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/penguatkuasaan.vue'),
            /* no children */
          },
  _definePage_default_55
  ),
  _mergeRouteRecord(
          {
            path: 'senarai',
            name: 'pengurusan-data-dasar-senarai',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/dasar/senarai.vue'),
            /* no children */
          },
  _definePage_default_56
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'index copy',
        name: 'pengurusan-data-index copy',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/index copy.vue'),
        /* no children */
      },
  _definePage_default_57
  ),
      {
        path: 'pembangunan',
        /* internal name: 'pengurusan-data-pembangunan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'kwc',
            name: 'pengurusan-data-pembangunan-kwc',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/kwc.vue'),
            /* no children */
          },
  _definePage_default_58
  ),
  _mergeRouteRecord(
          {
            path: 'ringkasan-peruntukan-dan-belanja-projek-bp1',
            name: 'pengurusan-data-pembangunan-ringkasan-peruntukan-dan-belanja-projek-bp1',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/ringkasan-peruntukan-dan-belanja-projek-bp1.vue'),
            /* no children */
          },
  _definePage_default_59
  ),
  _mergeRouteRecord(
          {
            path: 'smk',
            name: 'pengurusan-data-pembangunan-smk',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/smk.vue'),
            /* no children */
          },
  _definePage_default_60
  ),
  _mergeRouteRecord(
          {
            path: 'status-pelaksanaan-projek-bp1',
            name: 'pengurusan-data-pembangunan-status-pelaksanaan-projek-bp1',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-data/pembangunan/status-pelaksanaan-projek-bp1.vue'),
            /* no children */
          },
  _definePage_default_61
  )
        ],
      }
    ],
  },
  {
    path: '/pengurusan-maklumat',
    /* internal name: 'pengurusan-maklumat' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pengurusan-maklumat',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-maklumat/index.vue'),
        /* no children */
      },
  _definePage_default_62
  ),
  _mergeRouteRecord(
      {
        path: 'ePBT',
        name: 'pengurusan-maklumat-epbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-maklumat/ePBT.vue'),
        /* no children */
      },
  _definePage_default_63
  )
    ],
  },
  {
    path: '/pengurusan-pengguna',
    /* internal name: 'pengurusan-pengguna' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pengurusan-pengguna',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/pengurusan-pengguna/index.vue'),
        /* no children */
      },
  _definePage_default_64
  )
    ],
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/second-page.vue'),
    /* no children */
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/test.vue'),
    /* no children */
  },
  {
    path: '/utama',
    /* internal name: 'utama' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'ahli-pbt',
        name: 'utama-ahli-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/ahli-pbt.vue'),
        /* no children */
      },
  _definePage_default_65
  ),
  _mergeRouteRecord(
      {
        path: 'cctv',
        name: 'utama-cctv',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/cctv.vue'),
        /* no children */
      },
  _definePage_default_66
  ),
  _mergeRouteRecord(
      {
        path: 'e-book',
        name: 'utama-ebook',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/e-book.vue'),
        /* no children */
      },
  _definePage_default_67
  ),
  _mergeRouteRecord(
      {
        path: 'e-book copy',
        name: 'utama-ebook copy',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/e-book copy.vue'),
        /* no children */
      },
  _definePage_default_68
  ),
  _mergeRouteRecord(
      {
        path: 'fogt',
        name: 'utama-fogt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/fogt.vue'),
        /* no children */
      },
  _definePage_default_69
  ),
  _mergeRouteRecord(
      {
        path: 'haiwan-terbiar',
        name: 'utama-haiwan-terbiar',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/haiwan-terbiar.vue'),
        /* no children */
      },
  _definePage_default_70
  ),
  _mergeRouteRecord(
      {
        path: 'kempen',
        name: 'utama-kempen',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kempen.vue'),
        /* no children */
      },
  _definePage_default_71
  ),
  _mergeRouteRecord(
      {
        path: 'kesihatan',
        name: 'utama-kesihatan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kesihatan.vue'),
        /* no children */
      },
  _definePage_default_72
  ),
  _mergeRouteRecord(
      {
        path: 'kolam-renang',
        name: 'utama-kolam-renang',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/kolam-renang.vue'),
        /* no children */
      },
  _definePage_default_73
  ),
  _mergeRouteRecord(
      {
        path: 'lampu-jalan',
        name: 'utama-lampu-jalan',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/lampu-jalan.vue'),
        /* no children */
      },
  _definePage_default_74
  ),
  _mergeRouteRecord(
      {
        path: 'oku',
        name: 'utama-oku',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/oku.vue'),
        /* no children */
      },
  _definePage_default_75
  ),
  _mergeRouteRecord(
      {
        path: 'osc',
        name: 'utama-osc',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/osc.vue'),
        /* no children */
      },
  _definePage_default_76
  ),
  _mergeRouteRecord(
      {
        path: 'osc1',
        name: 'utama-osc1',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/osc1.vue'),
        /* no children */
      },
  _definePage_default_77
  ),
  _mergeRouteRecord(
      {
        path: 'pasar-awam',
        name: 'utama-pasar-awam',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pasar-awam.vue'),
        /* no children */
      },
  _definePage_default_78
  ),
  _mergeRouteRecord(
      {
        path: 'pasar-pbt',
        name: 'utama-pasar-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pasar-pbt.vue'),
        /* no children */
      },
  _definePage_default_79
  ),
  _mergeRouteRecord(
      {
        path: 'pbt',
        name: 'utama-pbt',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbt.vue'),
        /* no children */
      },
  _definePage_default_80
  ),
  _mergeRouteRecord(
      {
        path: 'pbtcare',
        name: 'utama-pbtcare',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbtcare.vue'),
        /* no children */
      },
  _definePage_default_81
  ),
  _mergeRouteRecord(
      {
        path: 'pbtPay',
        name: 'utama-pbt-pay',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/pbtPay.vue'),
        /* no children */
      },
  _definePage_default_82
  ),
  _mergeRouteRecord(
      {
        path: 'sanitasi',
        name: 'utama-sanitasi',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/sanitasi.vue'),
        /* no children */
      },
  _definePage_default_83
  ),
  _mergeRouteRecord(
      {
        path: 'spah',
        name: 'utama-spah',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/spah.vue'),
        /* no children */
      },
  _definePage_default_84
  ),
  _mergeRouteRecord(
      {
        path: 'tandas-awam',
        name: 'utama-tandas-awam',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/tandas-awam.vue'),
        /* no children */
      },
  _definePage_default_85
  ),
  _mergeRouteRecord(
      {
        path: 'test',
        name: 'utama-test',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/test.vue'),
        /* no children */
      },
  _definePage_default_86
  ),
  _mergeRouteRecord(
      {
        path: 'vektor',
        name: 'utama-vektor',
        component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor.vue'),
        children: [
  _mergeRouteRecord(
          {
            path: 'denggi',
            name: 'utama-vektor-denggi',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/denggi.vue'),
            /* no children */
          },
  _definePage_default_87
  ),
  _mergeRouteRecord(
          {
            path: 'dfic',
            name: 'utama-vektor-dfic',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/dfic.vue'),
            /* no children */
          },
  _definePage_default_88
  ),
  _mergeRouteRecord(
          {
            path: 'tikus',
            name: 'utama-vektor-tikus',
            component: () => import('/Volumes/PortableSSD/Documents/Vastcomp/flexi-jktgatewayvue3/src/pages/utama/vektor/tikus.vue'),
            /* no children */
          },
  _definePage_default_89
  )
        ],
      },
  _definePage_default_90
  )
    ],
  }
]
